export const SUCCESS_ICON = 'https://acko-cms.ackoassets.com/checked_green_fee00e8132.svg'
export const ERROR_ICON = 'https://acko-cms.ackoassets.com/cancel_red_0c99cfec79.svg'
